import Http from '@/support/http';

export default {
	getStudents(context, payload) {

		if (payload && payload.userId && payload.schoolClassId) {

			const route = `v1/student/user/${ payload.userId }?schoolClassId=${ payload.schoolClassId }`;

			return Http.get(route).then((response) => {

				response.data.forEach((value) => {

					if (!value.photoURL) {
						value.photoURL = 'assets/images/default-avatar.png';
					}

				});

				context.commit('SET_STUDENTS_LIST', response.data);

				return response;

			});

		}

	}, setStudent(context, payload) {
		context.commit('SET_STUDENT', payload);
	}, setStudentStatus(context, payload) {
		context.commit('SET_STUDENT_STATUS', payload);
	}, updateStudentList(context, payload) {
		context.commit('SET_STUDENTS_LIST', payload);
	}
};



// WEBPACK FOOTER //
// ./sources/domains/student/actions.js